module.exports = __webpack_public_path__ + "img/pingcebianjie_jpg_smzlpg.431ad28e.png";